var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{attrs:{"placeholder":"Поиск команды"},on:{"input":_vm.onInput},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }